var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"closeBtn",attrs:{"color":"red"},on:{"click":() => _vm.closeBtnHandler(false)}},[_c('v-icon',{attrs:{"color":"white darken-2"}},[_vm._v("close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }